// ─────────────────────────────────────────────────────────────────────────────
// Custom-customer shortcut codes
//
// These bypass the full backend pairing flow (no token, no /screens/pair API
// call) and just redirect the browser to a static menu URL on this same
// domain. Use this for white-glove deployments (Shawarma King, etc.) where
// the menu is hand-built HTML living under /custom/<slug>/ and we just want
// the TV to load it after entering a short code.
//
// To add a new shortcut:
//   1. Add an entry below: 'CODE': '/custom/<slug>/<tv>'
//   2. Rebuild player-web (`npm run build` inside player-web/)
//   3. Deploy with `./tools/deploy.sh --apply`
//
// Codes MUST be exactly 6 digits.
// ─────────────────────────────────────────────────────────────────────────────

const SHORTCUTS = {
  // Shawarma King — Austin, TX (legacy royal-theme menus)
  '482917': '/custom/shawarmakingusa/tv1',
  '482918': '/custom/shawarmakingusa/tv2',
  // Shawarma King — Mediterranean / bold-orange refresh
  '482937': '/custom/shawarmakingusa/tv11',
  '482938': '/custom/shawarmakingusa/tv22',
  // Shawarma King — Royal Reviews & Showcase (ad screen)
  '482933': '/custom/shawarmakingusa/tv33',
  // Shawarma King — The Royal Court Comedy (ad screen)
  '482944': '/custom/shawarmakingusa/tv44',
};

/**
 * If `code` is a known shortcut, redirect the browser to its target URL and
 * return true. Otherwise return false so the normal pairing lookup runs.
 */
export function tryShortcut(code) {
  const target = SHORTCUTS[code];
  if (!target) return false;
  // Use replace() so the back button doesn't bounce us straight back to /
  window.location.replace(target);
  return true;
}

export function listShortcuts() {
  return { ...SHORTCUTS };
}
